/**
 * The contract with the shop-floor spool, the process on the mini-PC that
 * connects **out** to the cloud, takes Modula commands and runs them on the LAN.
 *
 * The API lives in the cloud and cannot see MAINMODULA; the spool can. So the
 * API hands over the HTTP request it would have sent, and the spool hands back
 * what the WMS answered. Declared once, read by both sides.
 */
import { z } from 'zod';
/**
 * A request for the WMS, addressed by **path only**. The WMS address is known
 * to the spool alone: a job cannot point the spool at another machine on the
 * shop network.
 *
 * Or a label print (27/10/2026): the path `/etichette/<name>.pdf` and the PDF
 * in base64 as `corpo`. The spool writes it into the folder the label printer
 * watches and answers `201` with the name it used. Those two prefixes are all
 * the cloud can reach through the spool.
 */
export const zSpoolJob = z.object({
    id: z.string().min(1),
    metodo: z.enum(['GET', 'POST']),
    percorso: z.string().regex(/^\/(?!\/)/, 'solo il percorso, senza indirizzo: lo sa lo spool'),
    corpo: z.string().optional(),
    tipoContenuto: z.string().optional(),
    autorizzazione: z.string(),
    timeoutMs: z.number().int().positive(),
});
/** The answer to the spool's long-poll: a command, or `null` when the wait ended with none. */
export const zSpoolTake = z.object({ lavoro: zSpoolJob.nullable() });
/** What came back from the WMS: its reply, or why it could not be reached. */
export const zSpoolOutcome = z.union([
    z.object({ id: z.string().min(1), stato: z.number().int(), testo: z.string() }),
    z.object({ id: z.string().min(1), guasto: z.string() }),
]);
/** A commit short SHA, the tag of every image the pipeline builds. */
const zCommit = z.string().regex(/^[0-9a-f]{7,40}$/);
/**
 * The versions on both ends, for the mini-PC's updater: `versione` is what the
 * cloud runs — the spool must follow it — and `spool` the version the spool
 * last said it runs. `null` when unknown: an API started by hand has no
 * version, and a spool that has not asked since the API started has not said.
 */
export const zSpoolVersions = z.object({
    versione: zCommit.nullable(),
    spool: z.string().nullable(),
});
//# sourceMappingURL=spool.js.map